/* eslint-disable guard-for-in */
import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import { powerModuleStatus, prefixFile } from "@/fetch/fetchApi";
import RefreshGrid from "@/utils/refreshGrid";
import moment from "moment";
import { Tooltip } from "antd";
// 国际化切换语言
import { injectIntl } from "react-intl";

class ModalStruts extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.init();
  }

  componentDidMount() {
    const PARAM = {
      date: moment(new Date()),
      sn: this.props.sn,
    };
    this.fetchApi(PARAM);
  }

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "date",
          dateType: "pickYear",
          width: "100%",
          param: {
            name: "date",
            type: "object",
          },
          defaultValue: moment(new Date(), "YYYY"),
          required: !1,
          labelName: "年份选择",
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              icon: "search",
              text: "查询",
            },
            {
              btnType: "button",
              text: "导出",
              icon: "export",
              handler: (e, param) => {
                const searchParam = {
                  sn: this.props.sn,
                  year: param.date.format("YYYY"),
                  locale: "zh",
                };
                this.exportData(searchParam);
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        sn: this.props.sn,
      },
      autoLoadGrid: !0, // 设置为false不触发加载grid
      tableKey: "hisStubListTable",
    };

    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: "时间",
            key: "time",
            align: "center",
            colType: "textCol",
            render: (value) => {
              return value;
            },
          },
          {
            name: "状态码",
            colType: "textCol",
            key: "statusCode",
            align: "center",
          },
          {
            name: "详情",
            key: "msg",
            align: "center",
            colType: "textCol",
            render: (value) => {
              if (value) {
                return value.length > 34 ? <Tooltip title={value}>{value}</Tooltip> : value;
              } else {
                return "--";
              }
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pageCount: 10,
        },
        dataApi: powerModuleStatus,
        tableKey: "hisStubListTable",
        autoRefresh: !1, // 设置为true 直接加载grid数据
      },
    });
  }

  // 数据导出
  exportData(param) {
    const excelUrl = `${prefixFile}/exportPowerModuleFaultLog.do`;
    let params = "";
    Object.keys(param).forEach((keys) => {
      params += `${keys}=${param[keys]}&&`;
    });
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  }

  /**
   * 表格数据加载方法
   */
  fetchApi(param) {
    const newParam = param;
    const date = param.date;
    // 设置年、月参数
    newParam.year = date.format("YYYY");
    delete newParam.date;
    // 加载表格
    return RefreshGrid(this.context.store, "hisStubListTable", newParam);
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分${second}秒`;
    } else if (hour > 0) {
      return `${hour}时${minute}分${second}秒`;
    } else if (minute > 0) {
      return `${minute}分${second}秒`;
    } else {
      return `${second}秒`;
    }
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel overScroll">
          <ScGridTable config={this.state.tableConfig} unTotalMode />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(ModalStruts);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/module/modalStruts.js